<template>
  <div>
    <div class="row mb-2">
      <div class="form-group col-3 col-md-6">
        <check-permission
          v-if="!hideAddButton"
          :permissions="addButtonPermissions ? addButtonPermissions : getAddButtonPermissions()"
          :entityType="addButtonEntityType ? addButtonEntityType : entityType"
          :entityId="addButtonEntityId"
        >
          <button class="btn btn-smart btn-md rounded-pill" @click.prevent="$emit('add')">
            <i class="fal fa-fw fa-plus mr-1 d-none d-lg-inline-block" />

            <span>{{ $t(addButtonText) }}</span>
          </button>
        </check-permission>
      </div>
      <div class="col-9 col-md-6 text-md-right">
        <form v-if="!hideSearchInput" class="input-group mb-3" @submit.prevent="setSearch(search)">
          <input v-model="search" type="text" class="form-control left-pill" aria-describedby="button-addon2" />

          <div class="input-group-append">
            <button v-if="search" class="btn btn-outline-secondary btn-smart" type="button" @click="clearSearch">
              X
            </button>

            <button class="btn btn-outline-secondary btn-smart right-pill" id="button-addon2" type="submit">
              <i class="fal fa-fw fa-search mr-1 d-none d-lg-inline-block" />
              {{ $t('buttons.search') }}
            </button>
          </div>
        </form>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table">
        <t-head :columns="columns" :sort="sort" :actions="actions" :actionsWidth="actionsWidth" @order="order" />

        <tbody>
          <t-row
            v-for="(object, index) in data"
            :key="object.id || object.name + index"
            :object="object"
            :columns="columns"
            :actions="actions"
            :entityType="entityType"
            v-on="$listeners"
          />
        </tbody>

        <tfoot v-if="pages > 1" class="text-center">
          <tr>
            <td colspan="100%" style="text-align: center;">
              <button
                class="btn btn-light mr-2"
                v-for="page in pages"
                :key="'page' + page"
                :disabled="page === selectedPage"
                @click="setPage(page)"
              >
                {{ page }}
              </button>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import THead from './subcomponents/THead';
import TRow from './subcomponents/TRow';
import { DEFAULT_COUNT } from '@/utils/constants';
import { tryParseInt } from '@/utils/number';

// @vuese
// Tabela
export default {
  components: { THead, TRow },
  data() {
    return {
      sort: { order: this.$route.query.order, desc: this.$route.query.desc === 'true' },
      search: this.$route.query.search || ''
    };
  },
  props: {
    // Tablica zawierająca obiekty
    // {
    //   name : Nazwa property do wyświetlenia
    //   displayName: Nazwa do wyświetlenia w nagłówku tabeli
    //   width : string - szerokość kolumny w dowol nej jednostce
    //   sortName : Nazwa pola po którym ma sortować kolumny (jeśli nie ma to weźmie name)
    //   translate : boolean - Czy tłumaczyć zawartość kolumny
    // }
    columns: {
      type: Array,
      required: true
    },

    // Lista obiektów do wyświetlenia w tabeli
    // Property obiektu musi pasować do name w columns
    data: {
      type: Array,
      required: true
    },

    // Całkowita liczba obiektów wyświetlanych na liście
    total: {
      type: Number,
      required: true
    },

    // Liczba obiektów wyświetlanych na stronie
    perPage: {
      type: Number,
      required: false,
      default: DEFAULT_COUNT
    },

    // Lista obiektów akcji do wykorzystania
    // {
    //   event: Nazwa eventu do złapania
    //   name: Nazwa do wyświetlenia w przycisku
    //   icon: ikona do wyświetlenia w przycisku
    //   color: kolor przycisku
    //   class: klasa przycisku
    // }
    actions: {
      type: Array,
      required: false,
      default: () => []
    },

    // Szerokość kolumny z akcjami
    // Domyślnie 150px
    actionsWidth: {
      type: String,
      required: false
    },
    // Czy wyświetlić input z wyszukiwaniem
    hideSearchInput: {
      type: Boolean,
      required: false,
      default: false
    },
    // Czy ukryć przycisk dodawania
    hideAddButton: {
      type: Boolean,
      required: false,
      default: false
    },
    // Tekst przycisku do dodawania
    addButtonText: {
      type: String,
      required: false,
      default: 'buttons.add'
    },
    // Typ encji
    entityType: {
      type: String,
      required: false
    },
    // Nadpisanie uprawnień przycisku dodawania
    addButtonPermissions: {
      type: String,
      required: false
    },
    // Nadpisanie enitityId  przycisku dodawania
    addButtonEntityId: {
      type: [String, Number],
      required: false,
      default: undefined
    },
    // Nadpisanie entityType  przycisku dodawania
    addButtonEntityType: {
      type: String,
      required: false,
      default: undefined
    }
  },

  methods: {
    // @vuese
    // Ustawia stronę
    setPage(page) {
      this.reload({ ...this.$route.query, page });
    },
    // @vuese
    // Czyszczenie pola search
    clearSearch() {
      this.search = '';
      this.reload({ ...this.$route.query, search: undefined });
    },
    // @vuese
    // Ustawia wyszukiwaną frazę
    setSearch(search) {
      this.reload({ ...this.$route.query, search });
    },
    // @vuese
    // Przeładowuje stronę
    reload(query) {
      const nextRoute = { name: this.$route.name, params: this.$route.params, query };
      this.$router.replace(nextRoute);
    },
    // @vuese
    // Zmiana sortowania tabeli
    order(order) {
      this.sort = order;
      this.reload({ ...this.$route.query, ...order });
    },
    // @vuese
    // Ustawia uprawnienia przycisku dodawania
    getAddButtonPermissions() {
      return this.entityType.toUpperCase() + '.ADD';
    }
  },
  computed: {
    pages() {
      return Math.ceil(this.total / this.perPage);
    },
    selectedPage() {
      return tryParseInt(this.$route.query.page) || 1;
    }
  }
};
</script>
